import { Component } from '@angular/core';
import { ComponentVisibilityService } from '@approot/services/component-view/component-visibility.service';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';

@Component({
  selector: 'app-markets-detail',
  templateUrl: './markets-detail.component.html',
  styleUrls: ['./markets-detail.component.scss']
})
export class MarketsDetailComponent {
  constructor(
    private componentVisibilityService: ComponentVisibilityService,
    private productsConfigService: ProductsConfigService
  ) {}

  get forwardCurveArray() {
    return this.componentVisibilityService.forwardCurveArray;
  }

  get historicalGraphArray() {
    return this.componentVisibilityService.historicalGraphArray;
  }

  get volatilitySurfaceArray() {
    return this.componentVisibilityService.volatilitySurfaceArray;
  }

  get currencies() {
    return this.productsConfigService.productInfo.currencyPairs;
  }
}
